<template>
  <div :class="fxClassName">
    <div class="fxText-in">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: "FxText",
  props: {
    isLiquid: {
      type: Boolean,
      default: false
    },
    isTimerTrigger: {
      type: Boolean,
      default: false
    },
    delay: {
      type: Number,
      default: 500
    }
  },
  data() {
    return {
      isShow: false,
      isNext: false
    };
  },
  computed: {
    fxClassName: function() {
      let className = "fxText";
      className = this.isLiquid ? className + " is-liquid" : className;
      className = this.isShow ? className + " is-show" : className;
      className = this.isNext ? className + " is-next" : className;
      return className;
    }
  },
  mounted() {
    if (!this.isTimerTrigger) {
      const scene1 = this.$scrollmagic
        .scene({
          triggerElement: this.$el.firstChild,
          triggerHook: 0.5,
          offset: -50,
          duration: 300,
          reverse: false
        })
        .on("enter", () => {
          this.isShow = true;
          setTimeout(() => {
            this.isNext = true;
          }, 500);
        });
      // ---- ↓ triggerのヘルプを表示 ----
      //.addIndicators({ name: "OK" });

      this.$scrollmagic.addScene(scene1);
    } else {
      setTimeout(() => {
        this.isShow = true;
        setTimeout(() => {
          this.isNext = true;
        }, 500);
      }, this.delay);
    }
  }
};
</script>

<style scoped>
.fxText {
  display: inline-block;
  position: relative;
}
.fxText.is-liquid {
  width: 100%;
}
.fxText-in {
  display: inline-block;
  position: relative;
  visibility: hidden;
}
.fxText.is-liquid .fxText-in {
  width: 100%;
}
.is-next .fxText-in {
  visibility: visible;
}
.fxText:after {
  display: inline-block;
  width: 0;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: #fff;
  -webkit-transition-property: width;
  transition-property: width;
  -webkit-transition-duration: 0.4s;
  transition-duration: 0.4s;
  -webkit-transition-timing-function: cubic-bezier(1, 0, 0, 1);
  transition-timing-function: cubic-bezier(1, 0, 0, 1);
  content: "";
}
.fxText.is-show:after {
  width: 100%;
}
.fxText.is-next:after {
  left: auto;
  right: 0;
  width: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/atoms/FxText.vue